import React from "react";
import style from "../Style.module.css";

const Pattern8 = ({ color = "#2F2F2F", size = 263 }) => {
  const height = (size * 346) / 243;
  return (
    <svg
      className={style.svgBackground}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={height}
      viewBox="0 0 263 346"
      fill="none"
      style={{
        display: "block",
        margin: "0 auto", // จัดให้อยู่ตรงกลางแนวนอน
      }}
    >
      <path
        d="M233.526 328.614C227.513 325.788 220.317 323.381 211.149 321.183C220.317 318.985 227.513 316.578 233.526 313.752C260.043 301.403 262.901 279.844 262.901 271.157C262.901 262.47 260.043 240.911 233.526 228.561C227.513 225.736 220.317 223.329 211.149 221.131C220.317 218.933 227.513 216.526 233.526 213.7C260.043 201.351 262.901 179.791 262.901 171.105C262.901 162.418 260.043 140.859 233.526 128.509C227.513 125.683 220.317 123.276 211.149 121.078C220.317 118.881 227.513 116.474 233.526 113.648C260.043 101.298 262.901 79.7389 262.901 71.0523C262.901 62.3658 260.043 40.8064 233.526 28.4568C227.513 25.6311 220.317 23.224 211.149 21.0262C220.317 18.8284 227.513 16.4212 233.526 13.5955C260.043 1.24594 262.901 -20.3134 262.901 -29H192.42H51.7523C42.5847 -26.8022 35.3887 -24.3951 29.3756 -21.5693C2.8587 -9.21978 0 12.3396 0 21.0262C0 29.7127 2.8587 51.2721 29.3756 63.6217C35.3887 66.4474 42.5847 68.8545 51.7523 71.0523C42.5847 73.2501 35.3887 75.6572 29.3756 78.483C2.8587 90.8325 0 112.392 0 121.078C0 129.765 2.8587 151.324 29.3756 163.674C35.3887 166.5 42.5847 168.907 51.7523 171.105C42.5847 173.302 35.3887 175.71 29.3756 178.535C2.8587 190.885 0 212.444 0 221.131C0 229.817 2.8587 251.377 29.3756 263.726C35.3887 266.552 42.5847 268.959 51.7523 271.157C42.5847 273.355 35.3887 275.762 29.3756 278.588C2.8587 290.937 0 312.497 0 321.183C0 329.87 2.8587 351.429 29.3756 363.779C35.2901 366.5 42.289 368.802 51.1608 371H263C262.803 362.209 259.846 340.754 233.526 328.614Z"
        fill={color}
        opacity={0.1}
      />
    </svg>
  );
};

export default Pattern8;
